import React, { useState,useEffect,useRef } from "react";

import { Link,useParams } from "react-router-dom";
import axios from "axios";

import Skalaton from "../../../dataTables/skalaton";

import { useHookstate } from '@hookstate/core'
import Store from '../../../../store';
import $ from "jquery";
import DataTables from "datatables.net";
import Moment from 'moment';
import {brokerDsrAPI,brokerDsrTlAPI,brokerDsrbrokersAPI,dsrAPI} from "../../../../config/endpoints";

import Pie from "./charts/pie";
import "./style.css";
export default function DsrTl() {
  
  const params = useParams();
  const gState = useHookstate(Store);
  const [data, setData] = useState([]);
  
  const date = gState.fullDate.get();
  useEffect(() => {
    
    setData('');
      axios.post(brokerDsrTlAPI,{
          withCredentials:true,
          date:date,
          manager_id:params.id,
      })
        .then(function (response) {
          setData(response.data)
          
        }).catch(function (error) {
          console.log(error);
        });

      },[date,params]);

  return (
            <div className="all_pages_body mb-100" >
            

              <div className='container pt-5 '>
              
                <div className="card bg-white">
                  <div className="card-body">
                    
                    <div className="row">
                      <div className="col-md-6 text-start"> 
                          <h3 className="main-title pt-1">DSR Team Lead</h3>
                      </div>
                      <div className="col-md-6 ">
                          <input  type="date" className="shadow-sm px-2 py-1 border-0 float-end" id="filter-date" value={date} onChange={(e) => gState.fullDate.set(Moment(e.target.value).format('YYYY-MM-DD'))} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='container mt-3 py-3'>
                
                  <div className="row">
                    <div className="col-12">
                      <div className="card border-0 shadow">
                        <div className="card-body  bg-white rounded ">
                            <div className="container shadow min-vh-100 py-2">
                                <div className="table-responsive">
                                    <table className="table table0 accordion">
                                        <thead>
                                            <tr>
                                                <th scope="col" >SL</th>
                                                <th scope="col" >Team Lead</th>
                                                <th scope="col">Today Picups</th>
                                                <th scope="col">Today Drops</th>
                                                <th scope="col">Invoiced</th>
                                                <th scope="col">Ready To Invoice</th>
                                                <th scope="col">View Team</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        { (data.length<1)?
                                        <Skalaton rows="10" cols="7" />
                                        :data.map(function(q,l){
                                        return (
                                            <tr key={l}>
                                                <td>{l+1}</td>
                                                <td>{q.name}</td>
                                                <td>{q.child.todayPicups}</td>
                                                <td>{q.child.todaydrops}</td>
                                                <td>{q.child.invoiced}</td>
                                                <td>{q.child.readytoinvoice}</td>
                                                <td>
                                                  <Link  to={{ pathname: `/admin/dsr/broker/${q.tl_id}` }}>View Team
                                                  </Link>
                                                </td>
                                            </tr>)
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
  )
}


